import React from 'react';
import { Image } from 'antd';

import { ModalTitleSpace, ModalTitleTypography } from './ModalTitle.styles';

interface Props {
    title: string;
    icon?: string;
    style?: React.CSSProperties;
    className?: string;
}

const ModalTitle: React.FC<Props> = ({ title, icon, style, className }) => {
    return (
        <ModalTitleSpace className={['title-container', className].filter(Boolean).join(' ')} style={style}>
            {icon && <Image src={`src/assets/images/${icon}`} preview={false} />}
            <ModalTitleTypography>
                <strong>{title}</strong>
            </ModalTitleTypography>
        </ModalTitleSpace>
    );
};

export default ModalTitle;
